import { useEffect } from 'react';
import { connect } from 'react-redux';

import { setCamList } from '~/actions/camera';
import { updateCurrentEvent } from '~/actions/event';
import { setDonations } from '~/actions/donation';
import { isArchived, isSameDate, convertUTCToVenueTime } from '~/utils/helpers';
import { fixDateString } from '~/utils/date';
import { featureOn } from '~/utils/featureToggle';
import useWebSocket from 'react-use-websocket';
import { get, sortBy, isEqual } from 'lodash';

import { Feature } from '~/types/common';

const DONATION_WIDGET = featureOn(Feature.donation_widget);

const SocketClient = ({ donations, eventData, cameras, setDonations, updateCurrentEvent, setCamList }) => {
  const { lastJsonMessage, sendJsonMessage } = useWebSocket(ENV.WEBSOCKET_URL, {
    retryOnError: true,
    onError: console.error,
    shouldReconnect: (e) => {
      return !isArchived(eventData.status);
    },
    onOpen: (e) => {
      sendJsonMessage({ action: 'listenToEventStatus', eventId: eventData.id });
    },
  });

  useEffect(() => {
    if (lastJsonMessage && lastJsonMessage !== undefined) {
      //  Sometimes socket return date string with UTC at the end, which gives Error: invalid date so slice it till 16 char
      if (lastJsonMessage.start_date) {
        lastJsonMessage.start_date = lastJsonMessage.start_date.slice(0, 16) + ':00';
      }
      if (lastJsonMessage.end_date) {
        lastJsonMessage.end_date = lastJsonMessage.end_date.slice(0, 16) + ':00';
      }

      if (!isSameDate(eventData.start_utc, lastJsonMessage.start_date)) {
        const venueTime = convertUTCToVenueTime(lastJsonMessage, eventData.venue.timezone_id);
        const newData = {
          title: lastJsonMessage.title,
          status: lastJsonMessage.status,
          start_utc: lastJsonMessage.start_date,
          end_utc: lastJsonMessage.end_date,
          start: venueTime.venueStartTime,
          end: venueTime.venueEndTime,
        };
        updateCurrentEvent({ ...eventData, ...newData });
      }
      if (lastJsonMessage.status != eventData.status) {
        console.log('Event status change:', lastJsonMessage.status);
        const newData = {
          status: lastJsonMessage.status,
        };
        updateCurrentEvent({ ...eventData, ...newData });
      }
      if (!isEqual(lastJsonMessage.cameraStatus, cameras)) {
        setCamList(lastJsonMessage.cameraStatus);
      }
      if (DONATION_WIDGET && lastJsonMessage.eventDonations.length > donations?.length) {
        setDonations(sortBy(lastJsonMessage.eventDonations, donation => new Date(fixDateString(donation.createdDate)).getTime() * -1))
      }
    }
  }, [lastJsonMessage]);

  return [];
};

const mapDispatchToProps = (dispatch) => ({
  setDonations: (donations) => dispatch(setDonations(donations)),
  updateCurrentEvent: (value) => dispatch(updateCurrentEvent(value)),
  setCamList: (value) => dispatch(setCamList(value)),
});

const mapStateToProps = (state) => ({
  eventData: state.event.data,
  donations: state.donation.donations,
  cameras: get(state, 'camera.all', []),
});

export default connect(mapStateToProps, mapDispatchToProps)(SocketClient);
